import { render, staticRenderFns } from "./CatalogWorkflow.vue?vue&type=template&id=6c7e801c&scoped=true"
import script from "./CatalogWorkflow.vue?vue&type=script&lang=js"
export * from "./CatalogWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7e801c",
  null
  
)

export default component.exports